import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.entries.js";
/**
 * ServerRequest implementation
 */
export class ServerRequestImpl {
  constructor(data, context, response, params = {}) {
    this.body = data.body;
    // headers may contain array values (e.g., Set-Cookie), simplified to string here
    this.headers = {};
    if (data.headers) {
      for (var _i = 0, _Object$entries = Object.entries(data.headers); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        this.headers[key] = Array.isArray(value) ? value.join(', ') : value;
      }
    }
    this.cookies = data.cookies || {};
    this.path = data.path || '';
    this.params = params;
    this.requestId = data.requestId;
    this.origin = context.origin;
    this.source = context.source;
    this.res = response;
  }
}